import React, { useState } from 'react'

export default function UserProfileWithRating ({
  userImage = 'images/img_image_96x96.png',
  userName = 'Б. Энхжаргал',
  userTitle = 'Director of science and production',
  userDescription = 'Энэ компанийн үйлчилгээ маш мэргэжлийн бөгөөд найрсаг байлаа. Эмчилгээний талаархи мэдээллийг тодорхой, ойлгомжтой тайлбарласан нь итгэл төрүүлсэн.',
  star = 4,
}) {
  const stars = Array.from({ length: 5 }, (_, index) => index < star)
  const [isModalOpen, setIsModalOpen] = useState(false)
  // const [selectedTeamMember, setSelectedTeamMember] = useState(null)

  const callModal = member => {
    // setSelectedTeamMember(member)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    // setSelectedTeamMember(null)
  }

  return (
    <>
      <div
        className=' flex flex-col items-center w-[27.63rem] gap-[1.58rem]  mobile:w-full mobile:mb-5'
        style={{ marginRight: 20 }}
      >
        <div className='flex items-center gap-4 self-stretch'>
          <img
            src={userImage}
            alt='ll'
            className='h-[100%] w-[15%] rounded-[12px] object-contain '
          />
          <div className='flex flex-1 flex-col items-start'>
            <p className='font-sfpro text-[16px] font-bold text-blue_gray-600'>
              {userName}
            </p>

            <p className='font-sfpro text-[12px] font-normal text-blue_gray-600'>
              {userTitle}
            </p>
          </div>
        </div>
        <div className='flex items-center gap-2 self-stretch  mt-[-20px] mb-[-20px]'>
          {stars.map((isFilled, index) => (
            <span
              key={index}
              style={{
                color: isFilled ? '#edbc24' : '#e0e0e0',
                fontSize: '18px'
              }}
            >
              ★
            </span>
          ))}
        </div>
        <p
          className='text-[12px] font-normal cursor-pointer '
          onClick={callModal}
        >
          {userDescription.length > 188
            ? userDescription.substring(0, 188) + '...'
            : userDescription}
        </p>
      </div>

      {isModalOpen && (
        <div
          className='fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 mobile:p-5'
          onClick={closeModal}
        >
          <div
            className='w-[400px] h-[500px] bg-white p-5 flex flex-col shadow-xl rounded-2xl mobile:w-full mobile:h-[500px]'
            onClick={e => e.stopPropagation()}
          >
            <div className='flex items-center gap-4'>
              <img
                src={userImage}
                alt='ll'
                className='h-[100%] w-[15%] rounded-[12px] object-contain '
              />
              <div className='flex flex-1 flex-col items-start'>
                <p className='text-[16px] font-bold'>{userName}</p>
                <p className='text-[12px] font-normal'>{userTitle}</p>
              </div>

              <button className='mt-[-40px]' onClick={closeModal}>
                <img
                  src='https://icons.veryicon.com/png/o/miscellaneous/all-blue-icon/close-428.png'
                  alt='Close'
                  className='h-4 w-4'
                />
              </button>
            </div>
            <div className='flex items-center gap-2 self-stretch mt-2'>
              {stars.map((isFilled, index) => (
                <span
                  key={index}
                  style={{
                    color: isFilled ? '#edbc24' : '#e0e0e0',
                    fontSize: '18px'
                  }}
                >
                  ★
                </span>
              ))}
            </div>
            <p className='text-[12px] font-normal mt-2 '>{userDescription}</p>
          </div>
        </div>
      )}
    </>
  )
}
